import styled from 'styled-components'
import { InformationCircle } from '@styled-icons/ionicons-outline/InformationCircle'
import { GrayDark } from '../../../../constants/constants'

export const InformationIcon = styled(InformationCircle)`
  color: ${GrayDark};
`
export const Span = styled.span`
  margin-right: 3px;
`
